import { BackLink } from '../../components/back-link';
import sharedStyles from '../shared.module.css';
import { Button, cn, Link } from '@lhb/ui';
import { useRouteError } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { ErrorGrafik } from './assets/error-graphic';
import { MessageBlock } from '../../components/blocks';

export function BankIdError() {
  const { t } = useTranslation('BANKID_ERROR');
  const error = useRouteError() as Error;
  console.error('BankId Error:', error);
  const handledHintCodes = [
    'EXPIREDTRANSACTION',
    'CERTIFICATEERR',
    'USERCANCEL',
    'STARTFAILED',
  ];
  const isGenericError = !handledHintCodes.includes(error.message);
  return (
    <>
      <BackLink asChild label={t('CANCEL', { ns: 'COMMON' })}>
        <Button
          variant="tertriary"
          className={cn(sharedStyles['close'], sharedStyles['hide-mobile'])}
          trailingIcon="cross-small"
        />
      </BackLink>
      <h1 className={sharedStyles['heading']}>
        {error.message === 'EXPIREDTRANSACTION' ||
        error.message === 'STARTFAILED'
          ? t(`${error.message}_HEADING`)
          : t('ERROR_PAGE_LABEL')}
      </h1>
      <MessageBlock data-component="bankid-error">
        <Trans
          i18nKey={error.message}
          ns="BANKID_ERROR"
          defaults="<p>Någonting gick fel, var god försök igen.<br>Om problemet kvarstår, kontakta kundservice.</p>"
          components={{
            p: <p className={cn(sharedStyles['subtitle'])} />,
          }}
        />

        {isGenericError && (
          <div className={sharedStyles['error-code-wrapper']}>
            <div
              className={sharedStyles['error-code']}
            >{`${t('ERROR_CODE_LABEL')}: ${error.message}`}</div>
          </div>
        )}

        {error.message === 'STARTFAILED' && (
          <div className={sharedStyles['error-download-wrapper']}>
            <Link external to="install.bankid.com">
              {t('DOWNLOAD_LINK_TEXT')}
            </Link>
          </div>
        )}
      </MessageBlock>

      <ErrorGrafik width="13rem" className={sharedStyles['error-graphics']} />
      <BackLink
        className={
          isGenericError
            ? sharedStyles['generic-error-btn-wrapper']
            : sharedStyles['error-btn-wrapper']
        }
        asChild
        label={t('RESTART_BUTTON_LABEL')}
        to="../"
      >
        <Button />
      </BackLink>
      <BackLink asChild label="Avbryt">
        <Button
          variant="tertriary"
          className={cn(sharedStyles['close'], sharedStyles['hide-desktop'])}
          trailingIcon="cross-small"
        />
      </BackLink>
    </>
  );
}
